import React from 'react';
import { TFinalTest } from '../../../../../store/finalTest/types';
import { Content } from '../Content';
import { TextMessage } from '../TextMessage';
import { TextMessageMed } from '../TextMessageMed';
import { GROUP_SEMINAR, TYPE_ID } from '../../../../../utils/consts';
import { TextMessageWebinar } from '../TextMessageWebinar';
import { BlockNumbers } from './BlockNumbers';
import { BlockButtons } from './BlockButtons';

interface Props {
  isTest?: boolean;
  test: TFinalTest;
  groupId: number;
  typeId: number;
  onReview: (value: boolean) => void;
}

export const TestReview: React.FC<Props> = React.memo(({ isTest, test, groupId, typeId, onReview }) => {
  const [isResult, setIsResult] = React.useState(true);
  const [currentQuestion, setCurrentQuestion] = React.useState(0);

  React.useEffect(() => {
    setCurrentQuestion(0);
  }, []);

  const backHandler = () => {
    setIsResult(true);
  };

  const selectHandler = (idx: number) => {
    setCurrentQuestion(idx);
    setIsResult(false);
  };

  const clickHandler = () => {
    setCurrentQuestion(0);
    onReview(false);
  };

  if (!test.questions[currentQuestion]) {
    return null;
  }

  const renderMessage = (type: 'success' | 'fail') => {
    if (typeId === TYPE_ID.WEBINAR) {
      return <TextMessageWebinar isTest={isTest} test={test} type={type} />;
    }
    if (groupId === GROUP_SEMINAR.MED) {
      return <TextMessageMed test={test} type={type} />;
    }

    return <TextMessage test={test} type={type} />;
  };

  if (test.isDone && isResult) {
    return (
      <div style={{ textAlign: 'center' }}>
        {renderMessage('success')}
        <h2>Відповіді:</h2>
        <BlockNumbers questions={test.questions} myAnswers={test.myAnswers} onSelect={selectHandler} />
        <BlockButtons handleOverview={() => selectHandler(0)} />
      </div>
    );
  }

  if (!test.isDone && isResult) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        {renderMessage('fail')}
        <h2>Відповіді:</h2>
        <BlockNumbers questions={test.questions} myAnswers={test.myAnswers} onSelect={selectHandler} />
        <BlockButtons
          attemptLimit={test.attempt_limit}
          quantity={test.quantity}
          handleRepeat={clickHandler}
          handleOverview={() => selectHandler(0)}
        />
      </div>
    );
  }

  return (
    <div style={{ width: '100%', padding: '20px 50px' }}>
      <Content type="review" test={test} currentQuestion={currentQuestion} value={test.myAnswers ?? []} />
      <BlockNumbers current={currentQuestion} questions={test.questions} myAnswers={test.myAnswers} onSelect={selectHandler} />
      {test.isDone ? (
        <BlockButtons handleBack={backHandler} />
      ) : (
        <BlockButtons attemptLimit={test.attempt_limit} quantity={test.quantity} handleRepeat={clickHandler} handleBack={backHandler} />
      )}
    </div>
  );
});
